<template>
    <div class="grid-content">
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="From"
                v-model="cred.emailFrom"
                :validate="$v.cred.emailFrom"
                help-text="e.g. support@yourdomain.com"/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="Mailgun API Key"
                v-model="cred.apiKey"
                password
                :validate="$v.cred.apiKey"
                help-text="Your Mailgun API Key."/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="Mailgun Domain"
                v-model="cred.domain"
                :validate="$v.cred.domain"
                help-text="Your Mailgun Domain."/>
        </div>
    </div>
</template>

<script>
    import {email, required} from 'vuelidate/lib/validators';
    import BaseCredentials from './base-credentials';

    export default {
        name: 'mailgun',
        extends: BaseCredentials,
        validations: {
            cred: {
                emailFrom: {required, email},
                apiKey: {required},
                domain: {required},
            },
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'mailgun',
                    beforeValidation: () => this.isActiveType && this.$v.$touch(),
                    rules: () => (this.isActiveType ? [
                        {
                            name: `The Mailgun sender email is required.`,
                            delegate: () => !this.$v.cred.emailFrom.required,
                        },
                        {
                            name: `The Mailgun sender email must be valid.`,
                            delegate: () => !this.$v.cred.emailFrom.email,
                        },
                        {
                            name: `The Mailgun API key is required.`,
                            delegate: () => this.$v.cred.apiKey.$error,
                        },
                        {
                            name: `The Mailgun domain is required.`,
                            delegate: () => this.$v.cred.domain.$error,
                        },
                    ] : []),
                };
            },
        },
    };
</script>
